import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler, isDevMode, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// NGRX
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './app.reducer';


// // Modulos personalizados
// import { AuthModule } from './auth/auth.module';

// Environment
import { environment } from '../environments/environment';
import { ToastrModule } from 'ngx-toastr';

// Translation
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';



import { ModalCartShipingSheduleComponent } from './pages/modal-cart-shiping-shedule/modal-cart-shiping-shedule.component';
import { ModalCartShopSheduleComponent } from './pages/modal-cart-shop-shedule/modal-cart-shop-shedule.component';
//GOOGLE PLACES




import { ErrorHandlerService } from './services/error-handler.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CsrfInterceptor } from './interceptors/csrf.interceptor';
import { OnlyDecimalDirective } from './directives/number-only.directive';


export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/app/', '.json');
}


@NgModule({ declarations: [
        AppComponent,
        ModalCartShipingSheduleComponent,
        ModalCartShopSheduleComponent,
        OnlyDecimalDirective
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        // AuthModule,
        // AngularFirestoreModule.enablePersistence(),
        ToastrModule.forRoot({ timeOut: 3000, preventDuplicates: true, positionClass: 'toast-top-full-width' }),
        StoreModule.forRoot(appReducers),
        !environment.production ? StoreDevtoolsModule.instrument({
            maxAge: 25, // Retains last 25 states
            logOnly: environment.production, // Restrict extension to log-only mode
        }) : [],
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })], providers: [
        // { provide: ErrorHandler, useClass: ErrorHandlerService },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CsrfInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
	constructor() {
	}
}
